export default __webpack_public_path__ + "static/media/Congrats.3643983d.png";